import { render, staticRenderFns } from "./ComparadorArticulos.vue?vue&type=template&id=6cb0288a&scoped=true"
import script from "./ComparadorArticulos.vue?vue&type=script&lang=js"
export * from "./ComparadorArticulos.vue?vue&type=script&lang=js"
import style0 from "./ComparadorArticulos.vue?vue&type=style&index=0&id=6cb0288a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb0288a",
  null
  
)

export default component.exports